import React from 'react';
import SPADialog from '@/components/admin/SysadminSPA/shared/SPADialog';
import SlideAdminNotesPanel from './SlideAdminNotesPanel';
import type { SlideStatus } from './useSlideStatuses';

interface SlideAdminNotesDialogProps {
  initialNotes?: SlideStatus[];
  slideId: number;
  slidePosition: number;
  slideTitle: string;
  stafferId: number;
  statuses: string[];
}

const SlideAdminNotesDialog = ({
  initialNotes, slideId, slidePosition, slideTitle, stafferId, statuses,
}: SlideAdminNotesDialogProps) => (
  // overflow-visible on the content and body lets the inline status menu escape the dialog (see
  // SPAReuseLessonsModal); the panel paginates so long note lists don't push the dialog off screen.
  <SPADialog.Content className="tw-overflow-visible" size="lg">
    <SPADialog.Header>
      <SPADialog.Title>Admin Notes</SPADialog.Title>
      <SPADialog.Description className="tw-text-spa-secondary">
        Slide {slidePosition} · <b className="tw-font-semibold tw-text-spa-primary">{slideTitle}</b>
      </SPADialog.Description>
      <SPADialog.CloseButton />
    </SPADialog.Header>
    <SPADialog.Body className="tw-overflow-visible">
      <SlideAdminNotesPanel initialNotes={initialNotes} slideId={slideId} stafferId={stafferId} statuses={statuses} />
    </SPADialog.Body>
  </SPADialog.Content>
);

export default SlideAdminNotesDialog;
